/**
 * Homepage FAQ copy shared by visible FAQ UI and FAQPage JSON-LD.
 */
export interface HomepageFaqItem {
  question: string;
  paragraphs: readonly string[];
  link?: {
    href: string;
    label: string;
    afterText: string;
  };
}

export const HOMEPAGE_FAQ_ITEMS: readonly HomepageFaqItem[] = [
  {
    question: "What is Radivision?",
    paragraphs: [
      "Radivision is the Startup Streaming Network connecting millions of viewers to informative and entertaining content from and about startups, and sharing the amazing solutions and wealth they're delivering to the world.",
      "As a viewer, you can learn about, participate in, and prosper in the changes you want to see in the world while creating wealth through private and IPO investment opportunities.",
    ],
  },
  {
    question: "How big a market is the non-institutional individual investor?",
    paragraphs: [
      'The Public Markets represent companies that are traded on the public stock exchanges (e.g. the NYSE, Nasdaq.) or through other opportunities accessible to the non-institutional "retail", "consumer", or "main street" investors. Together, these investors have over $80T AUM in the US alone, and another $80T globally. 5-20% of these assets represent a potential $20T of new funds engaging in private market and IPO investments.',
    ],
  },
  {
    question: "Why is retail investor support and access to private market and IPO investments needed?",
    paragraphs: [
      "Prior to 1998, startups used to IPO - i.e have their Initial Public Offering and be listed on one of the stock exchanges – in 3-5 years, with much of their growth and profit potential still in the future where everyone could have access and growth wealth together.",
      "However, after the late 1990s, the financial markets' infrastructure changed due to several factors (e.g. decimalization, electronic trading, hedge fund and large banks' domination of early- stage venture deals, stockbroker disappearance, institutional domination, etc.). Companies had to take longer to grow into larger deal sizes to accommodate the large institutions' demands, and IPOs were delayed to today's 11-14 years after founding, with fewer than 1% of venture backed deals IPO-ing.",
    ],
  },
  {
    question: "Does investing in Private Startups create wealth and positive change?",
    paragraphs: [
      "The early, high-growth private years delivered 70% higher returns than the public markets, leaving retail investors - who typically invest in public market offerings exclusively - far behind economically, driving inflation and creating many other critical societal issues. Now, with IPOs delayed up to 14 years, retail investors do not have access to the higher ROI (Return on Investment) private investments. Without private market access, no matter how hard people work, save, or invest wisely, they can't create generational wealth at the same rate. They are falling into the global wealth gap that has been accelerating since the 1990s.",
      "Today, we are in the Entrepreneurial Revolution, where equity is the new money. Radivision is here to help everyone understand and participate in this new economy so everyone can grow wealth, more investors can contribute to capital formation, and more companies can be funded to deliver innovation and positive change to humanity - Everybody wins!",
    ],
    link: {
      href: "https://blog.radivision.com",
      label: "Radivision blog page",
      afterText: "You can learn more by visiting the ",
    },
  },
  {
    question: "How do I invest in a Startup?",
    paragraphs: [
      "Visit Pitch Planet to view pitch videos and longer episodes from Startups. Dive deeper into the company to learn more about their mission, product, fundraising and more. Then, connect directly with the Startup and learn about current investment opportunities. It's that simple.",
    ],
  },
  {
    question: "How can I learn more about Radivision?",
    paragraphs: [
      "Learn more on our About Page, where we explain our mission, vision, and values, and where you can watch our 3-minute video with more details.",
    ],
  },
];

export function homepageFaqAnswerText(item: HomepageFaqItem): string {
  const body = item.paragraphs.join(" ");
  if (!item.link) {
    return body;
  }
  return `${body} ${item.link.afterText}${item.link.label} (${item.link.href}).`.replace(/\s+/g, " ").trim();
}
